<div class="layout-footer">
    <span class="font-medium ml-2">Versão: {{versao}}</span>
</div>
